export default __webpack_public_path__ + "static/media/solar-roof-mobile.b332719c.jpeg";